import React from 'react';
import '../../assets/styles/SectionEyebrow.css';

const SectionEyebrow = ({ children, className = '' }) => (
  <p className={`eyebrow-tag ${className}`.trim()}>
    <span className="eyebrow-tag__dot" aria-hidden="true"></span>
    <span className="eyebrow-tag__label">{children}</span>
  </p>
);

export default SectionEyebrow;
